export * from './Logo';
export * from './Texts';
export const backgroundColor = '#282c34';
export { default as backgroundImage } from './assets/background-blurred.jpg';
export { default as mainBackgroundImage } from './assets/background.jpg';